import { createSelector } from 'reselect';

/**
 * Selector for barcode field configuration
 *
 * Returns the configuration for which fields should be scanned and in what order.
 * This allows customers to configure their barcode scanning workflow based on their needs.
 *
 * NOTE: Configuration is currently hardcoded for initial release.
 * Future enhancement: Move to company settings or user preferences to allow per-customer configuration.
 */

const BARCODE_FIELD_NAMES = {
  WORK_ORDER_ID: 'workOrderId',
  SEQUENCE_NUMBER: 'sequenceNumber',
  LOT: 'lot',
  SUB: 'sub',
  SPLIT: 'split',
};

// Hardcoded for v1 - will be moved to company settings in future release
const DEFAULT_BARCODE_FIELD_CONFIG = {
  fields: [
    { name: BARCODE_FIELD_NAMES.WORK_ORDER_ID, enabled: true },
    { name: BARCODE_FIELD_NAMES.SEQUENCE_NUMBER, enabled: true },
    { name: BARCODE_FIELD_NAMES.SUB, enabled: true },
    { name: BARCODE_FIELD_NAMES.LOT, enabled: true },
    { name: BARCODE_FIELD_NAMES.SPLIT, enabled: true },
  ],
};

/**
 * Get the barcode field configuration
 *
 * @returns {Object} Configuration object with field order and enabled status
 */
export const getBarcodeFieldConfig = createSelector(
  // Future: Add state parameter when configuration is stored in Redux
  // [state => state.barcodeConfig],
  [],
  () => {
    // Return hardcoded config for now
    return DEFAULT_BARCODE_FIELD_CONFIG;
  }
);

/**
 * Get only the enabled fields in order
 *
 * @returns {Array<string>} Array of enabled field names in order
 */
export const getEnabledBarcodeFields = createSelector(
  [getBarcodeFieldConfig],
  (config) => {
    return config.fields
      .filter((field) => {
        return field.enabled;
      })
      .map((field) => {
        return field.name;
      });
  }
);
